<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="8" sm12 xs24 v-for="button in 3" :key="`button-${button}`">
        <card align="center">
          <card-text>
            <btn @click.native.stop="showMenu($event,'buttons', {button})" icon-left="cursor-pointer" size="sm" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" :color-lightness="null" :title="$lang.leftClick">{{ $lang.leftClick }}</btn>
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="8" sm12 xs24 v-for="image in 3" :key="`image-${image}`">
        <card align="center">
          <card-title :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white">{{ $lang.rightClickOnTheImage }}</card-title>
          <card-text padding-off :class="['p-6']">
            <ambient-image rounded="md" @contextmenu.native="showMenu($event, 'images', {src: getImageUrl(image)}, image)" :spread="6" :src="getImageUrl(image)" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="24">
        <context-menu ref="context-menu" :context-data="contextData" :items="items" @item-click="onItemClick" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageContextMenu',
  mixins: [
    methods
  ],
  data () {
    return {
      menus: {},
      items: [],
      contextData: {}
    }
  },
  mounted () {
    this.getExternalData('context-menu.json', 'menus')
  },
  methods: {
    showMenu ($event, menu, contextData = {}) {
      this.items = this.menus[menu]
      this.contextData = contextData
      this.$refs['context-menu'].show($event)
    },
    onItemClick ($event) {
      this.log('item-click', 'context-menu', $event)
    },
    getImageUrl (index) {
      return `${this.$root.config.staticAssetsDir}/images/misc/image-0${index}.jpeg`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/context-menu.vue